import HomeScreen from './containers/HomeScreen';
import NotFoundScreen from './containers/NotFoundScreen';

export { HomeScreen, NotFoundScreen };

export default {
  HomeScreen,
  NotFoundScreen,
};
